// extracted by mini-css-extract-plugin
export default {"container":"suggestion_container__6BA5L","title":"suggestion_title__lITYJ","form":"suggestion_form__FCWhT","form_card":"suggestion_form_card__Iafa1"};